exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2UY3Db8ugxRrpg7rMWunIT{width:400px}", ""]);

// exports
exports.locals = {
	"textbox": "_2UY3Db8ugxRrpg7rMWunIT"
};